import Card from '../Card/Card';
import {
  EmptySlot,
  FELT_CARD_BACK_CLASS_NAME,
  FlameIcon,
} from '../FeltMat/feltParts';

const BURNT_BACKS = [
  {
    cardId: 'burnt-back-lower',
    className: '-rotate-8 grayscale-40 brightness-75',
  },
  {
    cardId: 'burnt-back-upper',
    className:
      'rotate-6 grayscale-40 brightness-85 shadow-[0_4px_10px_rgba(0,0,0,0.35)]',
  },
];

export default function BurntCards({ burntCount }: { burntCount: number }) {
  if (burntCount === 0) {
    return (
      <EmptySlot className="h-[calc(84*var(--card-unit))] w-[calc(58*var(--card-unit))]" />
    );
  }

  return (
    <div className="relative h-[calc(84*var(--card-unit))] w-[calc(58*var(--card-unit))]">
      {BURNT_BACKS.map(({ cardId, className }) => (
        <Card
          key={cardId}
          card={{ cardId }}
          className={`${FELT_CARD_BACK_CLASS_NAME} absolute inset-0 ${className}`}
        />
      ))}
      <span
        aria-hidden="true"
        className="absolute -right-[8px] -bottom-[8px] flex size-[26px] items-center justify-center rounded-full bg-burn text-burn-ink shadow-[0_2px_6px_rgba(0,0,0,0.35)]"
      >
        <FlameIcon size={14} />
      </span>
    </div>
  );
}
